exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#paginationHolder{height:150px;padding:0 20px}.pagination li:not(active){cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/views/pagination/pagination.css
// module id = 241
// module chunks = 0